module.exports = __webpack_public_path__ + "static/media/comp-alert-bell-icon.7603f1a3.svg";